import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import caret from "../images/chevron-up.png";

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: #000029;
  color: white;
  position: fixed;
  bottom: 0;
  transform: ${(props) =>
    props.isOpen
      ? `translateY(0px)`
      : `translateY(${props.collapsedHeight}px)`};
  transition: transform 0.5s;

  h3 {
    padding: 24px;
  }
`;

const Main = styled.div`
  display: flex;
  max-width: 1152px;
  margin: auto;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  &:hover {
    cursor: pointer;
  }

  h3 {
    font-size: 16px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }

  img {
    width: 16px;
    height: 16px;
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.5s;
  }
`;

const Pre = styled.pre`
  padding: 0 24px 24px 24px;
  max-width: 1152px;
  margin: auto;
  margin-bottom: 0px;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
  overflow: scroll;
  overflow-x: scroll;
  max-height: 50vh;
`;

const Line = styled.span`
  display: block;
  padding-left: 30px;

  &::before {
    content: "${(props) => props.int}";
    position: absolute;
    opacity: 0.4;
    width: 24px;
    text-align: right;
    left: 8px;
  }
`;

const Code = ({ code }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(2000);
  const ref = useRef(null);
  const string = JSON.stringify(code, null, 2);
  const lines = string.split("\n");

  useEffect(() => setHeight(ref.current.clientHeight), [isOpen, code.length]);

  return (
    <>
      <div style={{ height: "56px" }} />
      <Container isOpen={isOpen} ref={ref} collapsedHeight={height - 56}>
        <Main isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <h3>JSON Response</h3>
          <img src={caret} alt="open json response" />
        </Main>
        <Pre>
          <code>
            {lines.map((line, index) => (
              <Line key={index + line} int={index + 1}>
                {line}
              </Line>
            ))}
          </code>
        </Pre>
      </Container>
    </>
  );
};

export default Code;
